import styled from "@emotion/styled";

import { setFullViewportWidthWithMaxPageWidthStyles } from "~/lib/styles";

import PlusSvg from "./plus.svg?url";

export const Divider = styled.div`
  position: relative;
  z-index: -1;

  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;

  block-size: 1px;

  background-color: #dddddd;

  &::before,
  &::after {
    content: "";

    display: block;
    flex: none;

    inline-size: 30px;
    block-size: 5px;

    outline: #ffffff solid 4px;
  }

  &::before {
    background-color: #ffca05;
  }

  &::after {
    background-color: #001246;
  }

  &:last-child {
    display: none;
  }

  ${props => props.theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthWithMaxPageWidthStyles()}
  }
`;

export const PlusDivider = styled.div`
  position: relative;
  z-index: -1;

  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;

  block-size: 1px;

  background-color: #dddddd;

  &::after {
    content: "";

    display: block;
    flex: none;

    inline-size: 12.56px;
    block-size: 13.34px;

    background-image: url(${PlusSvg});
    background-repeat: no-repeat;
    background-size: contain;

    outline: #ffffff solid 8px;
  }

  &:last-child {
    display: none;
  }

  ${props => props.theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthWithMaxPageWidthStyles()}
  }
`;
